import { queryKeys } from '../../lib/queryKeys';
import type { RequestError } from '../../shared';
import { observableToPromise } from '../../shared/observableToPromise';
import { type AuditLogEntryDetailResponse, getAccountAuditLogEntryDetail } from '../api';
import type { Account } from '../model';

import { useConditionalQuery } from './useAccountQuery';

export function useAuditLogEntryDetail(account: Account | null | undefined, entryUrl: string | null | undefined) {
  return useConditionalQuery<AuditLogEntryDetailResponse | null, RequestError>(
    account && entryUrl
      ? queryKeys.accounts.auditLogEntryDetail(account._id, entryUrl)
      : ['accounts', 'audit-entry-detail', null, entryUrl ?? null],
    ({ signal }) =>
      account && entryUrl
        ? observableToPromise(getAccountAuditLogEntryDetail(account, entryUrl), signal)
        : Promise.resolve(null),
    Boolean(account && entryUrl),
  );
}
